<script setup lang="ts">
import type { FooterFields } from "@citizenm/foundation/shared/types/contentful";

defineProps<{
  navigationGroups: FooterFields["footerNavigation"];
  socialLinks: FooterFields["showSocialLinks"];
  legalLinks: FooterFields["legalLinks"];
  disclaimer: FooterFields["disclaimer"];
}>();
</script>

<template>
  <footer class="footer">
    <div class="footer__container container">
      <LayoutNavigationGroups
        class="footer__navigation-groups"
        :navigation-groups="navigationGroups"
      />
      <LayoutSocialLinks :enabled-socials="socialLinks" />
      <LayoutLegalLinks class="footer__legal-links" :legal-links="legalLinks" />
      <span class="footer__disclaimer">{{ disclaimer }}</span>
    </div>
  </footer>
</template>

<style scoped lang="scss">
@use "@citizenm/lobby/assets/styles/utils/mixins" as mixins;

.footer {
  position: relative;
  bottom: 0;
  padding-block: 2.5rem;
  color: var(--primary-white, #fff);
  background-color: var(--primary-black, #000);

  &__container {
    max-width: var(--max-width, 1200px);
    margin: auto;
  }

  &__navigation-groups {
    margin-bottom: 0.5rem;
  }

  &__legal-links {
    margin-top: 1.75rem;
  }

  &__disclaimer {
    display: inline-block;
    margin-top: 1.125rem;
    font-size: 0.75rem;
    font-family: var(--font-family, sans-serif);
  }
}
</style>
